import React, { useMemo } from 'react';
import {
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
  Cell,
  Legend,
} from 'recharts';
import PropTypes from 'prop-types';
import { currency } from 'Helpers/Formats';

export default function DonutChart({
  height, data: unsortedData, colors, ...rest
}) {
  const { data, total } = useMemo(() => {
    if (!unsortedData || unsortedData.length === 0) {
      return { total: 0 };
    }
    let totalVal = 0;
    unsortedData.forEach((d) => {
      totalVal += d.value;
    });
    // Sort data to ensure consistent colors
    const sortedData = unsortedData.slice(0); // Make a copy of the original prop because you can't modify a react `useState` value directly
    sortedData.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
    return { data: sortedData, total: totalVal };
  }, [unsortedData]);

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart {...rest}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={height * 0.85}
          outerRadius={height}
          dataKey="value"
          nameKey="name"
          paddingAngle={1}
        >
          {data.map((entry, index) => (
            <Cell fill={colors[index % colors.length]} />
          ))}
        </Pie>
        <Legend
          align="right"
          verticalAlign="middle"
          height={36}
          layout="vertical"
        />
        <Tooltip
          formatter={value => `${currency(value)} (${Math.round((value / total) * 100)}%)`
          }
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
DonutChart.propTypes = {
  height: PropTypes.number,
  data: PropTypes.array,
  colors: PropTypes.array,
};

DonutChart.defaultProps = {
  height: 150,
  data: [],
  colors: ['#195A7C', '#38987b', '#DCCCA3', '#C37D92', '#D05353'],
};
